"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_CODES = void 0;
// Error codes returned by the API as { error: { code, message } }.
// The admin console translates codes, so messages here are for logs only.
exports.ERROR_CODES = [
    'VALIDATION_FAILED',
    'UNAUTHENTICATED',
    'SESSION_EXPIRED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'INVALID_CREDENTIALS',
    'ACCOUNT_LOCKED',
    'ACCOUNT_DISABLED',
    'TOO_MANY_ATTEMPTS',
    'PASSWORD_CHANGE_REQUIRED',
    'PASSWORD_POLICY',
    'WRONG_CURRENT_PASSWORD',
    'INVALID_RESET_TOKEN',
    'INVALID_SCOPE',
    'ORIGIN_NOT_ALLOWED',
    'STATUS_MOVE_NOT_ALLOWED',
    'REASON_REQUIRED',
    'NOT_A_COURIER',
    'USE_DRIVER_APP',
    'ROUTE_START_BLOCKED',
    'NOTHING_LOADED',
    'CALL_LOCKED',
    'NO_PHONE',
    'DELIVERY_INCOMPLETE',
    'ATTEMPT_INCOMPLETE',
    'BAD_FILE',
    'MAINTENANCE',
    'SYSTEM_LOCKED',
    'JOB_RUNNING',
    'INVALID_TWO_FACTOR_CODE',
    'TWO_FACTOR_EXPIRED',
    'TWO_FACTOR_SETUP_REQUIRED',
    'INTERNAL',
];
//# sourceMappingURL=errors.js.map